<div class="flex flex-col items-center w-screen h-screen bg-chathams-blue">
  <div class="max-w-sm h-auto m-0">
    <img src="assets/images/logo-login.png" alt="Olive logo" />
  </div>

  <div class="w-96 text-center">
    <h1 class="mt-6 text-lg text-white">Esqueceu sua senha?</h1>
    <p class="text-base leading-5 text-white mt-9">
      Não se preocupe! Enviaremos um link para o seu
      <strong class="italic">E-mail</strong> com a
      <strong class="italic">recuperação de senha</strong>
    </p>
    <p class="text-center text-white mt-9">Basta inseri-lo no campo abaixo:</p>
  </div>

  <form class="mx-2 w-96" [formGroup]="recoverPasswordForm" (ngSubmit)="recover()">
    <input class="form-input-custom" type="email" placeholder="E-mail" formControlName="email" />

    <button type="submit" class="w-full h-10 mt-4 btn btn--secondary">Enviar E-mail</button>
  </form>
</div>

<app-recover-password-modal *ngIf="showModal" [email]="email"></app-recover-password-modal>
